import "core-js/stable";
import { LoginRouter } from "@/routers/LoginRouter.tsx";
import { Cvpartner, setCvPartner } from "@/shared/bootstrap/cvpartner.ts";
import "./application_styles.ts";

// Here be dragons
const cvpartner = new Cvpartner(LoginRouter);
setCvPartner(cvpartner);
cvpartner.init();
// LastPass and 1Password overlays are hidden app-wide, and unhidden here: this is
// the one page where filling a password is the point.
document.body.classList.add("allow_password_autofill_apps_on_page");
